import { oembedAll } from './OembedStore';

export const updateOembedAll = (value) => oembedAll.update((oldValue) => value);
